__turbopack_context__.v({
  "active": "AddToCard-module-scss-module__GDclvq__active",
  "icon": "AddToCard-module-scss-module__GDclvq__icon",
});
